// Formatação de número
const numberFormat = (number, decimals = 0, decimalSeparator = '.', thousandSeparator = ',') => {
    number = parseFloat(number);
    if (isNaN(number)) return '';

    const fixedNumber = number.toFixed(decimals);
    const parts = fixedNumber.split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

    let formattedNumber = integerPart;
    if (parts.length === 2) {
        formattedNumber += decimalSeparator + parts[1];
    } else if (decimals > 0) {
        formattedNumber += decimalSeparator + '0'.repeat(decimals);
    }

    return formattedNumber;
};

export {numberFormat}